import { IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { IWpbDetail, IWpbSearch } from "./wpbTypes";


class WpbService {
    async page(searchVo: IWpbSearch, config: object = {}) {
        const apiUrl = "/gtm/warning/payment";
        return await httpRequest.post<IPage<IWpbDetail>>(apiUrl, searchVo, config);
    }
    //导出
    async export(searchVo: IWpbSearch) {
        const appPageUrl = "/gtm/warning/payment/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }

}

export const wpbService = new WpbService();
